import script from "./kalio-long-text-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-long-text-input.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__